import React, { useState } from 'react';
// import { useSelector } from 'react-redux';
import { Button, ModalIsland } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../utils/localization';

import { invertedMessages } from './messages';

import './CertsGlobalError.css';

/**
 * CertsGlobalError Component
 *
 * @description
 * CertsGlobalError is a React functional component that renders a modal
 * displaying an error message when the certification page fails to load
 * due to a network issue. It provides the user with options to refresh
 * the page or navigate back to the previous page.
 *
 * @component
 *
 * @returns {JSX.Element} A modal component with error details and action buttons.
 *
 * @example
 * <CertsGlobalError />
 *
 * @features
 * - Displays a critical error modal with a title, subtitle, and action buttons.
 * - Allows the user to refresh the page by clicking the "Refresh" button.
 * - Provides a "Go Back" button for navigating to the previous page.
 * - The modal can be dismissed by closing it using the `onClose` handler.
 *
 * @dependencies
 * - React hooks: `useState` for managing the modal open state.
 * - React Router: `useHistory` for navigation to the previous page.
 * - Components: `ModalIsland` for rendering the modal, `Button` for actions.
 *
 * @usage
 * - Intended for use in pages that may encounter network-related errors during data loading,
 *   which is global blockage for the application.
 *
 * @implementation
 * - `isOpen` (state): Controls the visibility of the modal.
 * - `onRefreshClick`: Reloads the page using `window.location.reload`.
 * - `onBackClick`: Navigates to the previous page using `history.goBack`.
 */
function CertsGlobalError() {
  const [isOpen, setIsOpen] = useState(true);

  const l = useInvertedLocalize(invertedMessages);
  // const { certsListGen2 } = useSelector((state) => state?.user);

  const onRefreshClick = () => {
    window.location.reload();
  };

  const onBackClick = () => {
    window.history.back(); // handle browser click
    // if (certsListGen2 && parseInt(certsListGen2, 10)) {
    //   window.location.replace('/ECMv6/certification/list');

    //   return;
    // }

    // window.location.replace('/ECM/certification/list');
  };

  return (
    <ModalIsland
      className='CertsGlobalError'
      kind='critical'
      alertTitle={l('Could not Load Page')}
      alertSubtitle={l(
        'This page of the certification did not load properly due to a network issue. Please refresh or try again later.'
      )}
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
      primaryButton={
        <Button
          type='button'
          kind='filled'
          isEnabled
          size='medium'
          onClick={onRefreshClick}>
          {l('Refresh')}
        </Button>
      }
      secondaryButton={
        <Button type='button' kind='ghost' size='medium' onClick={onBackClick}>
          {l('Go Back')}
        </Button>
      }
    />
  );
}

export default CertsGlobalError;
